<details-antecedent v-if="options" :antecedent="options" :submitted="submitted" :can-delete="false"/>
